<template>
  <div>
    <CrudList
      title="Especialidades"
      storeName="Specialities"
      parentStoreName="Jobs"
      parentUrlKey="job_id"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      canSearch
    >
      
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
